module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['UIKit']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module UIKit URL not available') },
        init: (arg) => { throw new Error('Module UIKit URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['UIKit'].get(request),
      init: (arg) => {
        try {
          return window['UIKit'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: UIKit')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module UIKit not available') },
      init: (arg) => { throw new Error('Module UIKit not available') }
    })
    document.head.appendChild(script);
  });